/**
 * @generated SignedSource<<0aaee5002ebef904e85ec083b99450eb>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type sharedAccessPageRevokeMutation$variables = {
  id: string;
};
export type sharedAccessPageRevokeMutation$data = {
  readonly lockUtilizationGrantDeactivate: {
    readonly deactivatedAt: any | null | undefined;
    readonly id: string;
  };
};
export type sharedAccessPageRevokeMutation = {
  response: sharedAccessPageRevokeMutation$data;
  variables: sharedAccessPageRevokeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "UtilizationGrant",
    "kind": "LinkedField",
    "name": "lockUtilizationGrantDeactivate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deactivatedAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sharedAccessPageRevokeMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "sharedAccessPageRevokeMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "068dc336d88d029c6d4b9d8acd7fed14",
    "id": null,
    "metadata": {},
    "name": "sharedAccessPageRevokeMutation",
    "operationKind": "mutation",
    "text": "mutation sharedAccessPageRevokeMutation(\n  $id: UUID!\n) {\n  lockUtilizationGrantDeactivate(id: $id) {\n    id\n    deactivatedAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "541c66904875272d8ce2eaf57956d0a4";

export default node;
